import { render, staticRenderFns } from "./CoursePayment.vue?vue&type=template&id=1501fcdd"
import script from "../../services/student/course-payment.js?vue&type=script&lang=js&external"
export * from "../../services/student/course-payment.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports